import { Routes, Route } from 'react-router-dom'
import MainLayout from './MainLayout'
import DashboardPage from '@/pages/DashboardPage'
import TasksPage from '@/pages/TasksPage'
import CalendarPage from '@/pages/CalendarPage'
import InventoryPage from '@/pages/InventoryPage'
import ArchivePage from '@/pages/ArchivePage'
import SettingsPage from '@/pages/SettingsPage'
import GamificationPage from '@/pages/GamificationPage'

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="gamification" element={<GamificationPage />} />
        <Route path="archive" element={<ArchivePage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  )
}
